(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["party-join-hero"] && !Shopify.designMode) return;
  try {
    
  /* Thumbnail wall: every few seconds, fade one random tile to a thumbnail that isn't showing */
  if (!customElements.get('party-mosaic')) {
    class PartyMosaic extends HTMLElement {
      connectedCallback() {
        this.pool = (this.dataset.pool || '').split('|').filter(Boolean);
        this.delay = Number(this.dataset.speed) || 2000;
        if (this.pool.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        this.onScreen = false;
        this.observer = new IntersectionObserver(([entry]) => {
          this.onScreen = entry.isIntersecting;
          this.onScreen ? this.start() : this.stop();
        });
        this.observer.observe(this);

        this.onVisibility = () => (document.hidden ? this.stop() : this.onScreen && this.start());
        document.addEventListener('visibilitychange', this.onVisibility);
      }

      disconnectedCallback() {
        this.stop();
        this.observer?.disconnect();
        if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
      }

      start() {
        if (!this.timer) this.timer = setInterval(() => this.swap(), this.delay);
      }

      stop() {
        clearInterval(this.timer);
        this.timer = null;
      }

      swap() {
        // Only tiles shown at the current screen size
        const box = this.getBoundingClientRect();
        const tiles = [...this.querySelectorAll('[data-tile]')].filter((tile) => {
          const r = tile.getBoundingClientRect();
          return r.width > 0 && r.bottom > box.top && r.top < box.bottom && r.right > box.left && r.left < box.right;
        });
        if (!tiles.length) return;

        let tile = tiles[Math.floor(Math.random() * tiles.length)];
        if (tiles.length > 1 && tile === this.lastTile) tile = tiles[(tiles.indexOf(tile) + 1) % tiles.length];
        this.lastTile = tile;

        const showing = new Set(tiles.map((t) => t.dataset.src));
        const unused = this.pool.filter((src) => !showing.has(src));
        const choices = unused.length ? unused : this.pool.filter((src) => src !== tile.dataset.src);
        if (!choices.length) return;
        const src = choices[Math.floor(Math.random() * choices.length)];

        const img = new Image();
        img.alt = '';
        img.className = 'is-entering';
        img.src = src;
        const reveal = () => {
          tile.appendChild(img);
          tile.dataset.src = src;
          requestAnimationFrame(() => requestAnimationFrame(() => img.classList.remove('is-entering')));
          setTimeout(() => [...tile.querySelectorAll('img, svg')].slice(0, -1).forEach((old) => old.remove()), 1100);
        };
        img.decode ? img.decode().then(reveal, () => {}) : (img.onload = reveal);
      }
    }
    customElements.define('party-mosaic', PartyMosaic);
  }

  } catch(e) { console.error(e); }
})();
})();
